// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"e2396a21","129":"5c9b8b1b","149":"fc56898a","239":"c71856ed","445":"2c95b7f1","520":"6fb3bde9","638":"dea5281b","738":"ffcf7553","971":"4b78010c"}[chunkId] + ".chunk.js";
};